<template>
  <div class="con-card px3 py2">
    <div class="flex">
      <div class="flex-auto">
        <template v-if="showHeaders">
          <span class="ti-tag ti-tag-sector-low ti-tag-small">{{verticalTitle(vertical)}}</span>
          <span class="ti-tag ti-tag-technology-low ti-tag-small">{{techTitle(tech)}}</span>
        </template>
        <span v-if="attrs===null" style="color:red;">REMOVED</span>
        <span v-else-if="draft" style="color:red;">DRAFT</span>
      </div>
      <a v-if="!preview" class="btn btn-primary" @click="showModal=true"
         title="Contact the vendor to find out more about these capabilities.">
        Enquire
      </a>
      <div v-else style="width: 40%;">
        <span class="detail-prop-title"> Contacts:</span><br/>
        {{contacts}}
      </div>
      <EnquireModal v-if="showModal" @close="showModal=false"
                    :capId="capId" :vendorId="vendorId" :vendorName="vendorName"
                    :enquirer="enquirer" :tech="tech" :vertical="vertical"
                    >
      </EnquireModal>
    </div>

    <template v-for="prop in attrs">
      <div v-if="prop.val" :key="prop.title">
        <h3 class="detail-prop-title">{{prop.title}}</h3>
        <p class="ti-p">{{prop.val}}</p>
      </div>
    </template>
  </div>
</template>

<script>

import EnquireModal from './EnquireModal.vue';

export default {
  name: 'CapabilityCard',
  components: { EnquireModal },
  props: {
    capId: null,
    vendorId: null,
    vendorName: null,
    enquirer: null,
    preview: null,
    draft: null,
    contacts: null,
    tech: null,
    vertical: null,
    // on AdminCap label is passed directly, for end-user from refMap
    showHeaders: { type: Boolean, default: true },
    attrs: null,
  },
  data() {
    return {
      showModal: false,
    };
  },

  methods: {
  },
};
</script>

<style>

.con-card {
  /* grey / fill */
  background: #FAFBFC;

  /* grey / border */
  border: 1px solid #DFE1E5;
  box-sizing: border-box;
  border-radius: 4px;
}

.con-card .detail-prop-title {
  padding-top: 10px;
  padding-bottom: 0px;
}

</style>
